module.exports = __webpack_public_path__ + "static/img/ttl-certificate.26d1370.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/ttl-certificate.svg
// module id = Rrwo
// module chunks = 1